import React from 'react';
import Link from 'next/link';

import StatusBadge from '@core/components/dashboardcoursecard/statusbadge/StatusBadge';
import { Box, LinearProgress } from '@mui/material';
import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';

import PremiumBadge from 'assets/icons/premium-badge.svg';
import CompletedIcon from 'assets/icons/completed-icon.svg';
import InProgressIcon from 'assets/icons/inprogress-icon.svg';
import NotStartedIcon from 'assets/icons/notstarted-icon.svg';
import ArrowRightIcon from 'assets/icons/arrow-right.svg';
import AssessmentNotStarted from 'assets/icons/assessment-notstarted.svg';
import AssessmentCompleted from 'assets/icons/assessment-completed.svg';
import AssessmentImage from 'assets/images/pages/career-path/assessment-card.png';

import classes from './AssessmentCard.module.scss';

const AssessmentCard = ({ data, wrapperRef }) => {
    const link = (data.last_status === 'passed' || data.last_status === 'failed') ? '/result' : `/${data.slug}`;
    return (
        <div className={classes['wrapper']} ref={wrapperRef}>
            <div className={classes['icon-wrapper']}>
                {data.last_status === 'passed' ? (
                    <AssessmentCompleted />
                ) : (
                    <AssessmentNotStarted />
                )}
            </div>
            <Link href={`/assessments/${data.id}${link}`} className='w-100'>
                <div className={classes['card-wrapper']}>
                    {/* <img src={AssessmentImage.src} alt={data.title} /> */}
                    <img src={data.image} alt={data.title} />
                    <div className={classes['content']}>
                        <div>
                            <h5>Assessment</h5>
                            <h3>{data.title}</h3>
                            <p>{data.short_introduction}</p>
                            {/* <div
                                className={classes['highlights']}
                                dangerouslySetInnerHTML={{ __html: data.bullet_highlights }}
                            >

                            </div> */}
                        </div>
                        <div className={`d-flex justify-content-between align-items-md-center align-items-start  flex-md-row flex-column ${classes['status-wrapper']}`}>
                            <div className={classes['progress-wrapper']}>
                                {data.last_status === 'passed' ? (
                                    <div className={classes['status-passed']}>
                                        Passed
                                    </div>
                                ) : data.last_status === 'failed' ? (
                                    <div className={classes['status-failed']}>
                                        Failed
                                    </div>
                                ) : (
                                    <div className={classes['questions-count']}>
                                        {data.question_count} questions
                                    </div>
                                )}
                            </div>
                            <div>
                                <div className={classes['btn']}>
                                    {(data.last_status === 'passed' || data.last_status === 'passed') ? (
                                        <>
                                            View Result
                                            <ArrowRightIcon />
                                        </>
                                    ) : (
                                        <>
                                            Start Assessment
                                            <ArrowRightIcon />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={classes['proficiency-badge']}>
                            <ProficiencyBadge proficiency={data.proficiency} />
                        </div>
                    </div>

                </div >
            </Link>
        </div>
    );
};

export default AssessmentCard;